<template>
  <!-- 日常维护 -->
  <div class="maintenance">
    <div class="main_container">
      <div class="list-row list_2">
        <div class="list-title title-header">异常列表</div>
        <div class="list bar" ref="list1">
          <template v-for="(item, index) in personList">
            <div :key="index" class="list-item">
              <div class="list-item-head">
                <div class="img-icon1">
                  <img :src="item.photoLink" alt />
                </div>
              </div>
              <div class="list-text">
                <div class="items">
                  <span>{{ item.instrumentName }}</span>
                </div>
                <div class="items tow-columns">
                  <div class="left_item">
                    <span>编号：</span>
                    <span>{{ item.serialNumber }}</span>
                  </div>
                  <div class="rigth_item">
                    <template v-if="item.states == 0">
                      <span class="state1">
                        <i class="iconfont icon-zhengchang"></i>
                        <span>正常</span>
                      </span>
                    </template>
                    <template v-if="item.states == 1">
                      <span class="state3">
                        <i class="iconfont icon-jiangji"></i>
                        <span>降级</span>
                      </span>
                    </template>
                    <template v-if="item.states == 2">
                      <span class="state2">
                        <i class="iconfont icon-tingyong_line"></i>
                        <span>停用</span>
                      </span>
                    </template>
                    <template v-if="item.states == 3">
                      <span class="state3">
                        <i class="iconfont icon-weixiu"></i>
                        <span>需维修</span>
                      </span>
                    </template>
                    <template v-if="item.states == 4">
                      <span class="state3">
                        <i class="iconfont icon-shebeijiandingshiyongren"></i>
                        <span>需检定</span>
                      </span>
                    </template>
                    <template v-if="item.states == 5">
                      <span class="state3">
                        <i class="iconfont icon-icon"></i>
                        <span>需保养</span>
                      </span>
                    </template>
                    <template v-if="item.states == 6">
                      <span class="state3">
                        <i class="iconfont icon-icon"></i>
                        <span>报废</span>
                      </span>
                    </template>
                  </div>
                </div>
              </div>
              <div class="list-btn">
                <el-button v-waves size="small" @click="anomaly(item)">处置</el-button>
              </div>
            </div>
          </template>
          <p class="foter" v-if="!noMore1">加载中...</p>
          <p class="foter" v-if="noMore1">没有更多了</p>
        </div>
      </div>
      <div class="list-row list_2">
        <div class="list-title title-header">待保养列表</div>
        <div class="list bar" ref="list2">
          <template v-for="(item, index) in maintainList">
            <div :key="index" class="list-item">
              <div class="list-item-head">
                <div class="img-icon1">
                  <img :src="item.photoLink" alt />
                </div>
              </div>
              <div class="list-text">
                <div class="items">
                  <span>{{ item.instrumentName }}</span>
                </div>
                <div class="items tow-columns">
                  <div class="left_item">
                    <span>编号：</span>
                    <span>{{ item.serialNumber }}</span>
                  </div>
                  <div class="rigth_item">
                    <template v-if="item.states == 5">
                      <span class="state3">
                        <i class="iconfont icon-icon"></i>
                        <span>需保养</span>
                      </span>
                    </template>
                    <!-- <span class="state2">
                    <span class="yuandian"></span>
                    <span>需保养</span>
                  </span> -->
                  </div>
                </div>
              </div>
              <div class="list-btn">
                <el-button v-waves size="small" @click="upkeep(item)">保养</el-button>
              </div>
            </div>
          </template>
          <p class="foter" v-if="!noMore2">加载中...</p>
          <p class="foter" v-if="noMore2">没有更多了</p>
        </div>
      </div>
      <div class="list-row list_3">
        <div class="list-title-jd title-header">
          <div class="title-v">
            待检定列表
          </div>
          <span class="button-v" v-if="isOpenVerify">
            <el-button v-waves size="small" @click="delVerificeOnline">在线送检</el-button>
          </span>
        </div>
        <div class="list bar" ref="list3">
          <!-- <transition name="slide-fade"> -->
          <template v-for="(item, index) in verification">
            <div :key="index" class="list-item h140p">
              <div class="list-item-head">
                <div class="img-icon3">
                  <img :src="item.photoLink" alt />
                </div>
              </div>
              <div class="list-text">
                <div class="items">
                  <span>{{ item.instrumentName }}</span>
                </div>
                <div class="items tow-columns">
                  <div class="left_item">
                    <span>编号：</span>
                    <span>{{ item.serialNumber }}</span>
                  </div>
                  <div class="rigth_item">
                    <template v-if="item.states == 4">
                      <span class="state3">
                        <i class="iconfont icon-shebeijiandingshiyongren"></i>
                        <span>{{ item.vertifyState }}</span>
                      </span>
                    </template>
                  </div>
                </div>
                <div class="other">
                  <span>检定到期时间：</span>
                  <span>{{ item.validityEffectiveTime }}</span>
                </div>
              </div>
              <div class="list-btn">
                <el-button v-waves size="small" @click="delVerifice(item)">检定</el-button>
              </div>
            </div>
          </template>
          <!-- </transition> -->
          <p class="foter" v-if="!noMore3">加载中...</p>
          <p class="foter" v-if="noMore3">没有更多了</p>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <div class="popout model">
      <el-dialog title="异常处置" :visible.sync="ycVisible" width="580px" :close-on-click-modal="false">
        <ycPopModel v-if="ycVisible" :message="popoData" @dispose="ycChange"></ycPopModel>
      </el-dialog>
      <el-dialog title="保养处置" :visible.sync="byVisible" width="800px" :close-on-click-modal="false">
        <byPopModel v-if="byVisible" :message="popoData" @dispose="byChange"></byPopModel>
      </el-dialog>
      <el-dialog title="检定处置" :visible.sync="jdVisible" width="900px" v-alterELDialogMarginTop="{marginTop:'5vh'}" :close-on-click-modal="false">
        <jdPopModel v-if="jdVisible" :message="popoData" @dispose="jdChange"></jdPopModel>
      </el-dialog>
    </div>
    <el-dialog title="在线送检" :visible.sync="onlineJdVisible" :destroy-on-close="true" width="900px" v-if="onlineJdVisible" :close-on-click-modal="false">
      <onlineTestModal :message="onJdPopoData" :deptId="userInfo.deptId" @handle-cancel="onlineCancel" @handle-submit="onlineSubmit"></onlineTestModal>
    </el-dialog>
    <el-dialog :visible.sync="detailVisible" width="1200px" v-if="detailVisible" top="5vh" :close-on-click-modal="false">
      <previewModel @cancel="cancelDetail" @save="save" @submitFiles="submitFiles" :preData="previewData"></previewModel>
    </el-dialog>
  </div>
</template>

<script>
import {
  getInstrumentList,
  getBrokeInsList,
  getMainta,
  getVerify,
  getAbnormal,
  GetVertifyInsList,
} from "@/api/depotApi";
import { CreateAsync } from "@/api/VertifyOrder";
import byPopModel from "./components/byPopModel1";
import jdPopModel from "./components/jdPopModel1";
import ycPopModel from "./components/yqPopModel";
import onlineTestModal from "./components/onlineTestModal";
import previewModel from "@/components/previewModel";
//新的
export default {
  components: {
    byPopModel,
    jdPopModel,
    ycPopModel,
    onlineTestModal,
    previewModel,
  },
  data() {
    return {
      ycVisible: false,
      byVisible: false,
      jdVisible: false,
      onlineJdVisible: false,
      popoData: {}, //传参
      onJdPopoData: {
        instrumentList: [],
      },
      loading2: false,
      loading1: false,
      loading: false,
      list1: "", //列表1
      list2: "", //列表2
      list3: "", //列表3
      userInfo: "",
      tabVla: 1,
      personIndex: 1, //所有仪器
      mainIndex: 1, //保养数量
      verificaIndex: 1, //检定下标
      maincTotal: 0, //保养总数数量
      personTotal: 0, //所有仪器总数数量
      verificaTotal: 0, //检定总数数量
      personList: [],
      maintainList: [],
      verification: [],
      detailVisible: false,
      previewData: null,
      isOpenVerify: false,
    };
  },
  computed: {
    noMore1() {
      return this.personList.length >= this.personTotal;
    },
    noMore2() {
      return this.maintainList.length >= this.maincTotal;
    },
    noMore3() {
      return this.verification.length >= this.verificaTotal;
    },
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
    this.isOpenVerify = this.$store.state.user.modulePower.openVerify;
  },
  mounted() {
    this.acquire(); //获取所有
    this.byList(); //获取保养列表数据
    this.JDList(); //获取检定列表
    //监听滚动事件
    this.list1 = this.$refs.list1;
    this.list2 = this.$refs.list2;
    this.list3 = this.$refs.list3;
    // console.log('元素',this.list1,this.list2,this.list3)
    // this.$nextTick(() => {
    this.list1.addEventListener("scroll", this.handleScroll1);
    this.list2.addEventListener("scroll", this.handleScroll2);
    this.list3.addEventListener("scroll", this.handleScroll3);
    // });
  },

  methods: {
    handleClick(index) {
      this.tabVla = index;
    },
    //获取异常仪器设备列表
    acquire(val) {
      let params = {
        deptId: this.userInfo.deptId,
        // depotId: 1,
        pageIndex: this.personIndex,
        pageSize: 10,
        deviceType: "1,2,3",
        ...val,
      };
      getBrokeInsList(params).then((res) => {
        if (res.code == 200) {
          this.personList = [...this.personList, ...res.data.records];
          this.personTotal = res.data.total;
        }
      });
    },
    //获取保养列表数据
    byList(val) {
      let params = {
        pageIndex: this.mainIndex,
        pageSize: 10,
        states: 5,
        deptId: this.userInfo.deptId,
        deviceType: "1,2,3",
        ...val,
      };
      getInstrumentList(params).then((res) => {
        if (res.code == 200) {
          this.maintainList = [...this.maintainList, ...res.data.records];
          this.maincTotal = res.data.total;
        }
      });
    },
    //获取检定列表数据
    JDList(val) {
      let params = {
        pageIndex: this.verificaIndex,
        pageSize: 10,
        states: 4,
        deptId: this.userInfo.deptId,
        deviceType: "1,2,3",
        ...val,
      };
      GetVertifyInsList(params).then((res) => {
        if (res.code == 200) {
          this.verification = [...this.verification, ...res.data.records];
          this.verificaTotal = res.data.total;
        }
      });
    },
    anomaly(item) {
      this.popoData = item;
      this.ycVisible = true;
    },
    upkeep(item) {
      this.popoData = item;
      this.byVisible = true;
    },
    delVerifice(item) {
      this.popoData = item;
      this.jdVisible = true;
    },
    delVerificeOnline() {
      this.onJdPopoData.instrumentList = this.verification;
      this.onlineJdVisible = true;
    },
    onlineCancel() {
      this.onJdPopoData = {
        instrumentList: [],
      };
      this.onlineJdVisible = false;
    },
    onlineSubmit(data) {
      this.previewData = data;
      this.onlineJdVisible = false;
      this.detailVisible = true;
    },
    // 保养处置
    byChange(operation, data) {
      if (operation) {
        getMainta(data).then((res) => {
          this.$message({
            message: "处理成功",
            type: "success",
          });
          this.mainIndex = 1;
          this.maintainList = [];
          this.getAllList();
          this.byVisible = false;
        });
      } else {
        this.byVisible = false;
      }
    },
    // 异常处置
    ycChange(operation, data) {
      if (operation) {
        getAbnormal(data).then((res) => {
          this.$message({
            message: "处理成功",
            type: "success",
          });
          this.personIndex = 1;
          this.personList = [];
          this.getAllList();
          this.ycVisible = false;
        });
      } else {
        this.ycVisible = false;
      }
    },
    // 检定处置
    jdChange(operation, data) {
      if (operation) {
        getVerify(data).then((res) => {
          if (res.code == "200") {
            this.$message({
              message: "处理成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.verificaIndex = 1;
          this.verification = [];
          this.getAllList();
          this.jdVisible = false;
        });
      } else {
        this.jdVisible = false;
      }
    },

    //处理滚动事件
    handleScroll1() {
      var scrollTop = this.list1.scrollTop;
      var windowHeitht = this.list1.clientHeight;
      var scrollHeight = this.list1.scrollHeight;
      //是否滚动到底部的判断
      if (scrollTop + windowHeitht == scrollHeight) {
        if (!this.noMore1) {
          this.personIndex++;
          this.acquire();
        } else {
          return;
        }
      }
    },
    handleScroll2() {
      var scrollTop = this.list2.scrollTop;
      var windowHeitht = this.list2.clientHeight;
      var scrollHeight = this.list2.scrollHeight;
      //是否滚动到底部的判断
      if (scrollTop + windowHeitht == scrollHeight) {
        if (!this.noMore2) {
          this.mainIndex++;
          this.byList();
        } else {
          return;
        }
      }
    },
    handleScroll3() {
      var scrollTop = this.list3.scrollTop;
      var windowHeitht = this.list3.clientHeight;
      var scrollHeight = this.list3.scrollHeight;
      //是否滚动到底部的判断
      if (scrollTop + windowHeitht == scrollHeight) {
        if (!this.noMore3) {
          this.verificaIndex++;
          this.JDList();
        } else {
          return;
        }
      }
    },
    getAllList() {
      this.personList = [];
      this.maintainList = [];
      this.verification = [];
      (this.personTotal = 0), //所有仪器总数数量
        (this.maincTotal = 0), //保养总数数量
        (this.verificaTotal = 0), //检定总数数量
        this.acquire(); //获取所有
      this.byList(); //获取保养列表数据
      this.JDList(); //获取检定列表
    },
    cancelDetail() {
      this.detailVisible = false;
    },
    save(data) {
      CreateAsync(data).then((res) => {
        if (res.code == "200") {
          this.$message.success("保存成功");
          this.getAllList();
          this.cancelDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    submitFiles(data) {
      CreateAsync(data).then((res) => {
        if (res.code == "200") {
          this.$message.success("送检成功");
          this.getAllList();
          this.cancelDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll1, true);
    window.removeEventListener("scroll", this.handleScroll2, true);
    window.removeEventListener("scroll", this.handleScroll3, true);
  },
};
</script>

<style lang="less" scoped>
//资源管理（领导用）搜索框与分页样式
.search-liest /deep/ .el-input__inner,
.el-button {
  /*background-color: rgba(0,0,0,0);*/
  color: #74c8fe;
  border: 2px solid #0192f1;
  border-radius: 6px;
  background: linear-gradient(
    0deg,
    rgba(0, 210, 255, 0.52),
    rgba(0, 57, 142, 0.52)
  );
}
.search-liest /deep/ input::-webkit-input-placeholder {
  color: #74c8fe;
}
.search-liest /deep/ .el-input,
.el-button:before {
  border-image: linear-gradient(
      -36deg,
      rgba(0, 156, 255, 0.94),
      rgba(0, 156, 255, 0.94)
    )
    2 2;
}
.search-liest /deep/ .el-button:active {
  background: deepskyblue;
}
.maintenance {
  .search-liest {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    .rigth-item {
      .actice {
        background: #169bd5;
        color: #ffffff;
      }
    }
  }
  .main_container {
    display: flex;
    .list_1 {
      overflow: auto;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .list-row {
      width: 33%;
      min-width: 420px;
      height: 820px;
      margin: 10px 6px;
      border: 2px solid#0090F0;
      border-radius: 4px;
      box-shadow: 0 0 33px#0090F0 inset;
      .yq-card-item {
        width: 100%;
        min-width: 420px;
        height: 350px;
        border-radius: 8px;
        border: 4px solid#0090F0;
        box-shadow: 0 0 33px#0090F0 inset;
        margin-bottom: 10px;
        // margin: 0.5%;
        float: left;
        .equip-item-top {
          width: 100%;
          height: 40%;
          background: linear-gradient(
            180deg,
            rgba(0, 210, 255, 0.52),
            rgba(0, 57, 142, 0.52)
          );
          .equip-imag {
            height: 100%;
            width: 100%;
            text-align: center;
          }
          .equip-detail {
            position: relative;
            .items {
              height: 30px;
              line-height: 30px;
              color: #74c8fe;
              font-size: 16px;
              margin-top: 10px;
              margin-left: 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .tow-columns {
              display: flex;
              justify-content: space-between;
              color: #74c8fe;
              /*line-height: 75%;*/
              font-size: 16px;
              margin-top: 10px;
              margin-left: 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              .left_item {
                width: 50%;
              }
              .rigth_item {
                width: 50%;
              }
            }
            .iconf-letf {
              position: absolute;
              right: 10px;
              top: -0px;
              i {
                font-size: 20px;
                color: #74c8fe;
              }
            }
          }
          .dian {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 100%;
            margin-right: 5px;
          }
        }
        .equip-item-bottom {
          width: 100%;
          height: 60%;
          background: rgba(8, 19, 41, 0.5);
          box-shadow: 0 0 15px #0071f1 inset;
          padding: 2% 4%;
          box-sizing: border-box;
          .row-item {
            color: #74c8fe;
            font-size: 16px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: 38px;
            line-height: 38px;
            .left_item {
              display: inline-block;
              width: 30%;
            }
            .rigth_item {
              display: inline-block;
              width: 68%;
            }
          }
          .dibu {
            display: flex;
            justify-content: space-between;
            i {
              margin-right: 4px;
            }
          }
        }
      }
      .list-title-jd {
        width: 100%;
        height: 80px;
        .title-v {
          line-height: 80px;
          height: 40px;
          text-align: center;
          font-size: 20px;
        }
        .button-v {
          margin-right: 18px;
          float: right;
        }
      }
      .list-title {
        height: 80px;
        width: 100%;
        line-height: 80px;
        text-align: center;
        font-size: 20px;
      }
      .list {
        height: calc(100% - 80px);
        overflow: hidden;
        overflow-y: auto;
        .list-item {
          height: 110px;
          margin-bottom: 10px;
          border-top: 2px solid#0090F0;
          border-bottom: 2px solid#0090F0;
          box-shadow: 0 0 15px #0071f1 inset;
          display: flex;
          &.h140p {
            height: 140px;
          }
          .list-item-head {
            width: 120px;
            height: 110px;
          }
          .list-text {
            width: calc(100% - 200px);
            padding: 10px;
            box-sizing: border-box;
            .items {
              height: 40px;
              color: #74c8fe;
              font-size: 20px;
              margin-top: 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .tow-columns {
              display: flex;
              justify-content: space-between;
              color: #74c8fe;
              margin-top: 0px;
              font-size: 16px;
              .left_item {
                width: 50%;
              }
              .rigth_item {
                width: 50%;
              }
            }
            .other {
              height: 40px;
              color: #74c8fe;
              font-size: 16px;
            }
          }
          .list-btn {
            width: 80px;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
  .foter {
    text-align: center;
    color: #74c8fe;
  }
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/maintenance/index.vue